// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kRR3","footerText":"Footer_footerText__2IEor","extraSpace":"Footer_extraSpace__2xZUg"};